import * as Dialog from '@radix-ui/react-dialog';

import { styled } from '@lichtblick/styled';
import { Colors, Spacing } from '@lichtblick/theme';

import { MessageDialog } from '../MessageDialog';

export const Content = styled(Dialog.Content)<{ $widthOverride?: string }>`
  background-color: ${Colors.white};
  bottom: 0;
  box-shadow: 0 0.25rem 0.5rem 0 rgba(16, 114, 186, 0.16);
  left: ${({ $widthOverride }) => ($widthOverride === '100vw' ? '0' : 'unset')};
  max-width: ${({ $widthOverride }) => $widthOverride ?? '48rem'};
  padding: ${Spacing.M} 0;
  position: fixed;
  right: ${({ $widthOverride }) => ($widthOverride === '100vw' ? 'unset' : '0')};
  top: 0;
  transition-property:
    color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter,
    backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  width: ${({ $widthOverride }) => $widthOverride ?? '75%'};
  z-index: var(--z-index-panel-drawer);
  @keyframes slideInFromRight {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(0);
    }
  }

  @keyframes slideOutToRight {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(100%);
    }
  }
  &[data-state='open'] {
    animation: slideInFromRight 0.5s ease-in-out;
  }
  &[data-state='closed'] {
    animation: slideOutToRight 0.3s ease-in-out;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xxs);
  padding: var(--spacing-xs);
  text-align: center;

  @media (min-width: 640px) {
    text-align: left;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  position: relative;
`;

export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const DrawerCloseButton = styled.div`
  position: absolute;
  right: var(--spacing-xs);
  top: var(--spacing-xs);
  z-index: var(--z-index-sticky);
`;

export const BusyOverlay = styled.div`
  align-items: center;
  background: ${Colors.darkBlue}66;
  display: flex;
  inset: 0;
  justify-content: center;
  pointer-events: auto;
  position: absolute;
  z-index: var(--z-index-panel-overlay);
`;

export const BusyOverlayContent = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${Spacing.Xs};
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: ${Spacing.Xs};
  width: 100%;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  padding: var(--spacing-xs);
`;

export const NegativeActionsContainer = styled.div`
  display: flex;
  gap: ${Spacing.Xxs};
`;

export const DeleteDialog = styled(MessageDialog)`
  background-color: ${Colors.red[10]};
  border: 2px solid ${Colors.red[100]};

  .dialogCloseButton {
    background-color: ${Colors.red[100]};
    svg {
      color: ${Colors.white};
    }
  }

  > div {
    > button:first-child {
      background-color: ${Colors.red[100]};
    }

    > button:nth-child(2) {
      border-color: ${Colors.red[10]};
      color: ${Colors.red[100]};
    }
  }
`;
